<div class="flex items-center justify-center min-h-screen mx-auto lg:-mt-20">
	<div class="flex flex-col w-full gap-2 px-6 mt-24 mb-8 text-center lg:mt-32">
		<uc-page-not-found-img-svg></uc-page-not-found-img-svg>
		<div class="my-4 sm:my-6">
			<h1 class="text-4xl font-bold tracking-tight text-gray-900 leading-12">
				This page does not exist.
			</h1>

			<p class="mt-4 mb-4 text-xl leading-6 text-gray-500 sm:text-base sm:mb-0">
				Sorry, we couldn't find the page you're looking for.
			</p>
			<p class="text-xl leading-6 text-gray-500 sm:text-base">
				Let's get back on track by using one of the links below.
			</p>
		</div>

		<div class="flex flex-col justify-center w-full gap-2 sm:flex-row sm:gap-3">
			<a
				routerLink="/"
				class="px-4 py-3 text-gray-900 border border-gray-200 rounded-full hover:bg-gray-50"
				>Home</a
			>
			<a
				routerLink="/courses"
				class="px-4 py-3 text-gray-900 border border-gray-200 rounded-full hover:bg-gray-50"
				>Course Search</a
			>
			<a
				routerLink="/personal-statement-examples"
				class="px-4 py-3 text-gray-900 border border-gray-200 rounded-full hover:bg-gray-50"
				>Personal Statements</a
			>
			<a
				routerLink="/prospectus"
				class="px-4 py-3 text-gray-900 border border-gray-200 rounded-full hover:bg-gray-50"
				>Prospectuses</a
			>
		</div>
	</div>
</div>

<div
	class="w-full p-4 py-8 mt-2 text-sm leading-6 text-center text-gray-500 border-t border-gray-200 sm:text-base"
>
	&copy; 2012 - {{ currentYear }} Uni Compare Ltd. All rights reserved.
</div>
